import styled from "styled-components"
import { SelectDropdown } from "client/components"

// eslint-disable-next-line import/prefer-default-export
export const SelectDropdownStyled = styled(SelectDropdown)`
    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        height: 30px;
        margin: 0;
        padding-right: 28px;
        font-size: ${(props) => props.theme.fontSizes.md}px;
        font-family: ${(props) => props.theme.openSans};
        font-weight: 600;
        user-select: none;
        background: none !important;
        color: ${(props) => props.theme.defaultTextColor};

        &::after {
            top: 16px;
            border-top-color: ${(props) => props.theme.defaultTextColor};
        }
    }
`
